/* eslint-disable react/no-array-index-key */
import { Suspense } from 'react';
import dynamic from 'next/dynamic';
import { Location } from 'location.d';
import { CardPreviousView, MatrixComponent, nameDataMatrixComponentCard } from 'matrix.d';
import { MATRIX_TYPE } from 'constants/index';

import { CarouselWrapper } from './components/CarouselWrapper/CarouselWrapper';
import { CarouselWrapperSkeleton } from './components/CarouselWrapper/CarouselWrapper.skeleton';

import { container } from './Matrix.css';

const BannerTopsort = dynamic(() => import('components/BannerTopsort/BannerTopsort'), { ssr: false });

interface MatrixProps {
  components: MatrixComponent[];
  userLocation: Location | null;
  cardPreviousView: CardPreviousView;
  matrixUuid: string;
  matrixType: string;
  specialUUIDs?: string[];
  prefixTrackingName?: string;
  hideTitle?: boolean;
  isCollectionSearchVariant?: boolean;
  isMobile?: boolean;
  bannerTopsort?: {
    positionIndex: number;
    id: string;
  }[];
}

export function Matrix({
  components,
  userLocation,
  cardPreviousView,
  matrixUuid,
  matrixType,
  prefixTrackingName,
  specialUUIDs = [],
  hideTitle = false,
  isCollectionSearchVariant = false,
  isMobile = true,
  bannerTopsort,
}: MatrixProps) {
  return (
    <div className={container} data-testid="matrix-container">
      {components.map((component, index) => {
        const response = component.response?.[nameDataMatrixComponentCard.DATA] || component.response?.[nameDataMatrixComponentCard.MATRICES] || [];
        const banner = bannerTopsort?.find((banner) => banner.positionIndex === index);
        return (
          <div key={`${component.uuid}-${index}`}>
            <Suspense
              fallback={(
                <CarouselWrapperSkeleton
                  type={component.response_type}
                  numberOfComponents={response?.length || 1}
                />
              )}
            >
              <CarouselWrapper
                key={`${component.uuid}-${index}`}
                component={component}
                prefixTrackingName={prefixTrackingName || matrixType || MATRIX_TYPE.MATRIX}
                matrixUuid={matrixUuid}
                matrixType={matrixType}
                cardPreviousView={cardPreviousView}
                userLocation={userLocation}
                specialUUIDs={specialUUIDs}
                hideTitle={hideTitle}
                isCollectionSearchVariant={isCollectionSearchVariant}
              />
            </Suspense>
            {banner && (
              <BannerTopsort isMobile={isMobile} idBanner={banner?.id} />
            )}
          </div>
        );
      })}
    </div>
  );
}
